/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ReadOnlyUserRole,
    ReadOnlyUserRoleFromJSON,
    ReadOnlyUserRoleFromJSONTyped,
    ReadOnlyUserRoleToJSON,
} from './';

/**
 * 
 * @export
 * @interface InlineResponse20044
 */
export interface InlineResponse20044 {
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20044
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20044
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20044
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<ReadOnlyUserRole>}
     * @memberof InlineResponse20044
     */
    results: Array<ReadOnlyUserRole>;
}

export function InlineResponse20044FromJSON(json: any): InlineResponse20044 {
    return InlineResponse20044FromJSONTyped(json, false);
}

export function InlineResponse20044FromJSONTyped(json: any, ignoreDiscriminator: boolean): InlineResponse20044 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': !exists(json, 'next') ? undefined : json['next'],
        'previous': !exists(json, 'previous') ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(ReadOnlyUserRoleFromJSON)),
    };
}

export function InlineResponse20044ToJSON(value?: InlineResponse20044 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'next': value.next,
        'previous': value.previous,
        'results': ((value.results as Array<any>).map(ReadOnlyUserRoleToJSON)),
    };
}


